// extracted by mini-css-extract-plugin
export var activeDot = "_23-c";
export var buttonContainer = "_23-9";
export var channelButton = "_23-a";
export var clickable = "_23-d";
export var content = "_23-0";
export var contentFull = "_23-2";
export var contentThird = "_23-1";
export var contentWrapper = "_23-7";
export var description = "_23-5";
export var heightShort = "_23-f";
export var image = "_23-3";
export var imageContainer = "_23-4";
export var selectButton = "_23-e";
export var spinnerContainer = "_23-b";
export var titleContent = "_23-8";
export var titleWrapper = "_23-6";